import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import React, { useState } from "react";
import PropTypes from "prop-types";

const DeleteForm = ({
  onDelete,
  data,
  onClose,
  type = "Item",
  displayField = "name",
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(data?.id);
    } finally {
      setLoading(false);
    }
  };

  const displayValue = data?.[displayField] || `this ${type}`;

  return (
    <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
      {/* TITLE */}
      <DialogTitle>
        <SoftTypography variant="h6" fontWeight="bold" color="error">
          Remove {type}
        </SoftTypography>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent dividers>
        <SoftTypography variant="body2">
          Are you sure you want to remove{" "}
          <strong>{displayValue}</strong>?
        </SoftTypography>
      </DialogContent>

      {/* ACTIONS */}
      <DialogActions sx={{ p: 2 }}>
        <SoftButton
          variant="outlined"
          color="secondary"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </SoftButton>

        <SoftButton
          variant="gradient"
          color="error"
          onClick={handleDelete}
          disabled={loading}
        >
          {loading ? "Deleting..." : `Delete ${type}`}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

DeleteForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  type: PropTypes.string,
  displayField: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.any,
  }),
};

export default DeleteForm;
